import axios from 'axios';
function obtenerInstructores() {
  return axios.get("/obtener_instructores")
    .then((response) => {
      if (response.data) {
        return response.data;
      } else {
        throw new Error(response.data.status);
      }
    })
    .catch((error) => {
      throw error;
    });
}
function crearInstructor(instructor) {
  try {
    const response = axios.post('/crear_instructor', instructor, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response;
  } catch (error) {
    return { status: 'fail', error };
  }
}
function actualizarInstructor(instructor) {
  return axios.post("/actualizar_instructor", instructor)
    .then((response) => {
      if (response.data) {
        return response.data;
      } else {
        throw new Error(response.data.status);
      }
    })
    .catch((error) => {
      throw error;
    });
}
function estadoInstructor(instructor) {
  return axios.post("/estado_instructor", instructor)
    .then((response) => {
      if (response.data) {
        return response.data;
      } else {
        throw new Error(response.data.status);
      }
    })
    .catch((error) => {
      throw error;
    });
}
function eliminarInstructor(instructorId) {
  return axios.post("/eliminar_instructor", { id: instructorId })
    .then((response) => {
      if (response.data && response.data.status === "success") {
        return response.data;
      } else {
        throw new Error(response.data.message || "Error desconocido");
      }
    })
    .catch((error) => {
      console.error("Error eliminando instructor:", error);
      throw error;
    });
}
export {obtenerInstructores, crearInstructor, actualizarInstructor, estadoInstructor, eliminarInstructor};
